<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <page-header title="Zonas"></page-header>
      </div>
      <div class="columns">
        <div
          v-for="item in zonas"
          :key="`zona-${item.id}`"
          :class="anchoColumna"
        >
          <zona
            ref="zona"
            :data="item"
            :alto="altoMaximo"
            @open-modal="abrirModalHandle"
          />
        </div>
      </div>
    </div>
    <b-modal
      :v-if="estaModalAbierto"
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <seleccion-usuario
        :bodega="bodega"
        :zona="zonaSeleccionada"
        @cancelar="cerrarModalHandle"
        @seleccionar="seleccionarUsuarioHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SeleccionUsuario from '@/components/configurador/usuariosZona/SeleccionUsuario.vue'
import Zona from '@/components/configurador/usuariosZona/Zona.vue'
import PageHeader from '@/components/shared/PageHeader.vue'
import { zonaService } from '@/services'

export default {
  name: 'UsuariosZona',
  components: {
    PageHeader,
    SeleccionUsuario,
    Zona
  },
  data() {
    return {
      altoMaximo: 0,
      estaModalAbierto: false,
      zonas: [],
      zonaSeleccionada: null
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    anchoColumna() {
      return `column${this.zonas.length < 4 ? ' is-4' : ''}`
    }
  },
  watch: {},
  created() {
    window.addEventListener('resize', this.calculateMonitorHeight)
  },
  mounted() {
    const self = this
    this.getZonas().then(() =>
      self.$nextTick(() => self.calculateMonitorHeight())
    )
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateMonitorHeight)
  },
  methods: {
    abrirModalHandle(payload) {
      this.zonaSeleccionada = payload
      this.estaModalAbierto = true
    },
    calculateMonitorHeight() {
      if (this.$refs.zona) {
        const windowHeight = window.innerHeight
        const monitorOffset = this.$refs.zona[0].$el.getBoundingClientRect().top
        this.altoMaximo = windowHeight - monitorOffset - 10
      }
    },
    cerrarModalHandle() {
      this.estaModalAbierto = false
    },
    getZonas() {
      const self = this
      return zonaService
        .getZonasByBodega(this.bodega.id)
        .then((response) => {
          self.zonas = response.data
            .filter((zona) => zona.estaActiva)
            .map((zona) => ({
              ...zona,
              actualizarUsuarios: false
            }))
        })
        .catch((error) => this.procesarError(error))
    },
    seleccionarUsuarioHandle(payload) {
      return zonaService
        .agregarUsuarioZona(payload.zona.id, payload.usuario.id)
        .then((response) => {
          this.notificarAccionCompletada(response.data)
          this.zonas = this.zonas.map((zona) => ({
            ...zona,
            actualizarUsuarios: true
          }))
        })
        .catch((error) => this.procesarError(error))
        .then((response) => (this.estaModalAbierto = false))
    }
  }
}
</script>
